import { useSelector } from "react-redux";
import "./HrAbsence.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Popover,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import { FiSearch } from "react-icons/fi";
import Select from "react-select";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { GridLoader, ScaleLoader } from "react-spinners";
import { formatStringToNumberV2 } from "../../../utils/genericFunctions.js";
import { customSelectStyles_dark, customSelectStyles_light, muiSelectStyles_dark, muiSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { MdAdd, MdClose, MdDelete, MdSave } from "react-icons/md";
import { useTranslation } from "react-i18next";
import { useRef } from "react";

const HrAbsence = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(true);
  const [absences, setAbsences] = useState([]);
  const [applicableStatuses, setApplicableStatuses] = useState([]);
  const [selectedAbsence, setSelectedAbsence] = useState({});

  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectedLeaveType, setSelectedLeaveType] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchLeaveTypes, setSearchLeaveTypes] = useState("");
  const [currencyAction, setCurrencyAction] = useState("");
  const [isCodeDialogOpened, setIsCodeDialogOpened] = useState(false);
  const [acCode, setAcCode] = useState(null);
  const [acTitle, setAcTitle] = useState(null);
  const [acStatus, setAcStatus] = useState({
    value: "New",
    label: "New"
  });
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [currentPage, setCurrentPage] = useState(0);

  const newCodeRef = useRef(null);
  const [definedLeaveTypes, setDefinedLeaveTypes] = useState([]);
  const [selectedDefinedLeaveType, setSelectedDefinedLeaveType] = useState(null);

  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });

  const [anchorEl, setAnchorEl] = useState(null);
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;


  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };


  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 8));
    setCurrentPage(0);
  };

  const fetchAbsences = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.post("/hrLeaveClass/findAll", {
        ac_status: "",
        result_limit: 100
      });
      setAbsences(res.data);
      setSelectedAbsence(res.data[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const definedStatuses = async () => {
    try {
      const options = ["New", "Active", "Under Review", "Closed"]?.map((val) => ({
        value: val,
        label: val,
      }));
      setApplicableStatuses(options);
    } catch (error) {
      console.error("Error fetching defined statuses :", error);
    }
  };

  const handleSearchAbsClass = async () => {
    try {
      if (searchTerm.length === 0) {
        setIsProcessing(true);
        const res = await newRequest.post(
          "/hrLeaveClass/search",
          {
            search_input: searchTerm,
            result_limit: 100
          }
        );
        if (res.data) {
          setAbsences(res.data);
          setLeaveTypes(res.data?.ac_types);
        }
      }
    } catch (error) {
      console.error("Error searching data:", error);
    } finally {
      setIsProcessing(false);
    }
  };


  const filteredAbsences = absences?.filter(
    (item) =>
      item?.ac_code?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
      item?.ac_title?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const filteredALeaveTypes = leaveTypes?.filter(
    (item) =>
      item?.leave_code?.toLowerCase().includes(searchLeaveTypes?.toLowerCase()) ||
      item?.leave_name_xx?.toLowerCase().includes(searchLeaveTypes?.toLowerCase())
  );


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteLimit") {


      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };



  const saveRecord = async (e) => {
    try {
      setIsProcessing(true);
      await newRequest.put(`/hrLeaveClass/upd/${selectedAbsence._id}`,
        {
          ac_code: selectedAbsence?.ac_code,
          ac_title: selectedAbsence?.ac_title,
          ac_status: selectedAbsence?.ac_status,
          ac_types: selectedAbsence?.ac_types || []
        }
      );
      showToast(t('updated'), "success");
      setIsProcessing(false);
    } catch (err) {
      console.log(err);
    }
  };


  const handleLeaveTypeChange = (value, rowId, field) => {
    try {
      // Convert to number for specific fields
      const parsedValue =
        field === "annual_hours" || field === "carry_over_hours"
          ? Number(value)
          : value;

      // 1. Update leaveTypes (UI table)
      const updatedLeaveTypes = leaveTypes.map((item) =>
        item._id === rowId
          ? { ...item, [field]: parsedValue, changed_xx: "Y" }
          : item
      );
      setLeaveTypes(updatedLeaveTypes);

      // 2. Update selectedAbsence.ac_types
      const updatedSelectedAbsence = {
        ...selectedAbsence,
        ac_types: updatedLeaveTypes,
      };
      setSelectedAbsence(updatedSelectedAbsence);

      // 3. Update absences list
      setAbsences((prev) =>
        prev.map((abs) =>
          abs._id === selectedAbsence._id
            ? { ...abs, ac_types: updatedLeaveTypes }
            : abs
        )
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleAbsenceClassData = (name, value, rowId) => {
    setSelectedAbsence((prev) => {
      return { ...prev, [name]: value };
    });
    setAbsences((prevData) =>
      prevData.map((item) =>
        item._id === rowId
          ? { ...item, [name]: value, changed_xx: "Y" }
          : item
      ));
  };


  const fetchDefinedLeaveTypes = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Leave Types" });
      const options = res.data?.map((val) => ({
        value: val?.sys_code,
        label: val?.sys_name,
      }));
      setDefinedLeaveTypes(options);
    } catch (error) {
      console.error("Error fetching entity types:", error);
    }
  };

  useEffect(() => {
    try {
      setAcCode(selectedAbsence?.ac_code);
      setAcTitle(selectedAbsence?.ac_title);
      setAcStatus({
        value: selectedAbsence?.ac_status,
        label: selectedAbsence?.ac_status
      });
      setLeaveTypes(selectedAbsence?.ac_types || []);
    } catch (error) {
      console.log(error);
    }
  }, [selectedAbsence]);

  useEffect(() => {
    fetchAbsences();
    definedStatuses();
    fetchDefinedLeaveTypes();
  }, []);

  return (
    <div className="hr-absence">
      {isLoading ? (
        <div className="no-content"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            height: "100%",
          }}
        >
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="hr-absence-main-wrapper">
          <div className="hr-absence-center-wrapper">
            <div className="center-details">
              <div className="center-navbar">
                <div className="navbar-left">
                  <span className="main-title">{selectedAbsence?.ac_title}</span>
                </div>
                <div className="navbar-right">
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="left"
                    endIcon={<MdSave />}
                    onClick={saveRecord}
                  >
                    {t('save')}
                  </CustomLoadingButton>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="right"
                    endIcon={<MdAdd />}
                    onClick={() => { }}
                  >
                    {t('newLeaveClass')}
                  </CustomLoadingButton>
                </div>
              </div>
              <div className="form-details-wrapper">
                <div className="form-details-left">
                  <div className="input-item-with-label">
                    <label
                      htmlFor="ac_title"
                      style={{
                        width: "150px",
                      }}
                    >
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      id="ac_title"
                      name="ac_title"
                      type="text"
                      placeholder={t('name').toUpperCase()}
                      value={selectedAbsence?.ac_title}
                      onChange={(e) => handleAbsenceClassData("ac_title", e.target.value, selectedAbsence?._id)}
                      className="form-input-item"
                      style={{ width: "400px" }}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="ac_code"
                      style={{
                        width: "150px",
                      }}
                    >
                      {t('code').toUpperCase()}
                    </label>
                    <input
                      id="ac_code"
                      name="ac_code"
                      type="text"
                      placeholder={t('code').toUpperCase()}
                      value={selectedAbsence?.ac_code}
                      onChange={(e) => handleAbsenceClassData("ac_code", e.target.value, selectedAbsence?._id)}
                      className="form-input-item"
                      style={{ width: "200px" }}
                      disabled
                    />
                  </div>
                </div>
                <div className="form-details-right">
                  <div className="input-item-with-label" style={{ alignSelf: "flex-end", paddingRight: "10px" }}>
                    <Select
                      id="ac_status"
                      name="ac_status"
                      menuPortalTarget={document.body}
                      styles={{
                        ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                        menuPortal: base => ({
                          ...base,
                          zIndex: 9999,
                        })
                      }}
                      width="200px"
                      value={applicableStatuses.find(option => option.value === selectedAbsence?.ac_status) || null}
                      onChange={selectedOption => handleAbsenceClassData("ac_status", selectedOption?.value, selectedAbsence?._id)}
                      options={applicableStatuses}
                      isSearchable={true}
                      placeholder={t('status')}
                    />
                  </div>
                </div>
              </div>
              <hr className="separator-h" />
              <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center", marginBottom: "5px" }}>
                <h2 className="main-title"> {t('leaveTypes').toUpperCase()}</h2>
                <CircularButton
                  currentTheme={currentTheme}
                  aria-describedby={id}
                  onClick={(e) => {
                    try {
                      setSelectedDefinedLeaveType(null);
                      setAnchorEl(e.currentTarget);
                      if (newCodeRef.current) {
                        newCodeRef.current.focus();
                      }
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  icon={<MdAdd color="green" />} width={"30px"} height={"30px"} />
              </div>
              {leaveTypes?.length > rowsPerPage &&
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    justifyContent: "space-between",
                    alignItems: "center",
                    margin: "10px 0px"
                  }}
                >
                  <div className="search-input-wrapper" style={{ width: "40%" }}>
                    <FiSearch className="search-input-icon" />
                    <input
                      className="search-input"
                      type="text"
                      placeholder="Search Leave Types..."
                      value={searchLeaveTypes}
                      onChange={(e) => setSearchLeaveTypes(e.target.value)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') handleSearchAbsClass();
                      }}
                    />
                    {searchLeaveTypes.length > 0 && (
                      <CloseIcon
                        onClick={async () => setSearchLeaveTypes("")}
                        className="search-input-icon"
                      />
                    )}
                  </div>
                  <TablePagination
                    rowsPerPageOptions={[8]}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleRowsPerPage}
                    component="div"
                    count={leaveTypes?.length}
                    rows={leaveTypes}
                    page={currentPage}
                    onPageChange={handlePageChange}
                  />
                </div>}
              {leaveTypes?.length > 0 &&
                <div className="table-content">
                  <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                    <Table sx={{ width: "max-content", border: 'none' }}>
                      <TableHead className="tablehead">
                        <TableRow className="tablerow">
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            #
                          </TableCell>
                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                            <span> {t('title').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                            <span> {t('annualHours').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                            <span> {t('carryOver').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                            <span> {t('carryOverHours').toUpperCase()}</span>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            <span>{t('action')}</span>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="tablebody">
                        {filteredALeaveTypes?.map((row, index) => (
                          <TableRow
                            key={row._id}
                            className={`${selectedLeaveType?._id === row._id ? "tablerow current" : "tablerow"}`}
                            onClick={() => setSelectedLeaveType(row)}
                          >
                            <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                              {currentPage * rowsPerPage + index + 1}
                            </TableCell>
                            <TableCell className="table-cell left" style={{ width: "auto" }}>
                              <span>{row?.leave_name_xx}</span>
                              <span className="sub-title soft" style={{ fontSize: "10px" }}>{row?.leave_code}</span>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                              <div className="input-item-with-label">
                                <input
                                  id="annual_hours"
                                  name="annual_hours"
                                  type="number"
                                  value={row?.annual_hours}
                                  onChange={(e) => handleLeaveTypeChange(e.target.value, row._id, "annual_hours")}
                                  style={{ width: "100%", textAlign: "right" }}
                                  className="form-input-item table"
                                />
                              </div>
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "120px" }}>
                              <ToggleSwitch
                                value={row?.carry_over}
                                onChange={(newValue) => handleLeaveTypeChange(newValue, row._id, "carry_over")}
                                label=""
                                labelPosition="end"
                                labelWidth="max-content"
                                border="N"
                              />
                            </TableCell>
                            <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                              <div className="input-item-with-label">
                                <input
                                  id="carry_over_hours"
                                  name="carry_over_hours"
                                  type="number"
                                  value={row?.carry_over_hours}
                                  onChange={(e) => handleLeaveTypeChange(e.target.value, row._id, "carry_over_hours")}
                                  style={{ width: "100%", textAlign: "right" }}
                                  className="form-input-item table"
                                  disabled={row?.carry_over === "N"}
                                />
                              </div>
                            </TableCell>
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                              <CircularButton
                                currentTheme={currentTheme}
                                onClick={async () => {
                                  try {
                                    const res = await newRequest.post(`/hrLeaveClass/removeLeaveType/${selectedAbsence._id}`, { leave_code: row?.leave_code });
                                    if (res.data?.msg === "removed") {
                                      setLeaveTypes((prevData) => prevData.filter(val => val?.leave_code !== row?.leave_code));
                                      showToast(t('removed'), "success");
                                    } else {
                                      showToast("Error deleting report!", "error");
                                    }
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }} color="#E53935" icon={<MdDelete/>} width={"30px"} height={"30px"} />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>}
            </div>
          </div>
          <div className="hr-absence-right-wrapper">
            <div className="search-input-wrapper" style={{ width: "95%" }}>
              <FiSearch className="search-input-icon" />
              <input
                className="search-input"
                type="text"
                placeholder={t('search')}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              {searchTerm.length > 0 && (
                <CloseIcon
                  onClick={() => {
                    try {
                      setSearchTerm("");
                      setCurrentPage(0);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                  className="search-input-icon"
                />
              )}
            </div>
            <div className="options-list">
              {filteredAbsences?.map((absence) => (
                <>
                  <span
                    key={absence._id}
                    className={`${selectedAbsence._id === absence?._id
                      ? "single-option active"
                      : "single-option"
                      }`}
                    onClick={async () => {
                      try {
                        setSearchLeaveTypes("");
                        setSelectedAbsence(absence);
                        setCurrentPage(0);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    <div className="title-row">
                      <span className="cy-title">{absence?.ac_title}</span>
                    </div>
                  </span>
                  <hr className="separator-h" />
                </>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton onClick={() => setIsNotifyDialogOpen(false)}> {t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}

      <Popover
        id={id}
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: "20px" }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "max-content",
            marginBottom: "5px"
          }}>
            <span className="main-title">{t('add').toUpperCase()}</span>
            <CircularButton currentTheme={currentTheme}
              onClick={() => {
                try {
                  setAnchorEl(null);
                  setSelectedDefinedLeaveType(null);
                } catch (error) {
                  console.log(error);
                }
              }} icon={<MdClose />} width={"35px"} height={"35px"} />
          </div>
          <div className="input-item-with-label" style={{ gap: "3px" }}>
            <Select
              id="selectedDefinedLeaveType"
              name="selectedDefinedLeaveType"
              menuPortalTarget={document.body}
              styles={{
                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                menuPortal: base => ({
                  ...base,
                  zIndex: 9999,
                })
              }}
              width="300px"
              value={selectedDefinedLeaveType}
              onChange={(selectedOption) => setSelectedDefinedLeaveType(selectedOption)}
              options={definedLeaveTypes}
              isSearchable={true}
              placeholder={t('leaveType').toUpperCase()}
            />
            <CustomLoadingButton
              currentTheme={currentTheme}
              iconPosition="end"
              borderRadiusType="right"
              endIcon={<MdAdd />}
              onClick={async () => {
                try {

                  if (!selectedDefinedLeaveType) {
                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText("Select leave type");
                    setIsNotifyDialogOpen(true);
                    return;
                  }

                  const res = await newRequest.post(`/hrLeaveClass/addLeaveType/${selectedAbsence._id}`,
                    {
                      leave_code: selectedDefinedLeaveType?.value,
                      annual_hours: 0,
                      carry_over: "N",
                      carry_over_hours: 0
                    }
                  );

                  if (res.data?.msg === "exists") {
                    setSelectedDefinedLeaveType(null);
                    showToast(t('leaveTypeExists', { param1: selectedDefinedLeaveType?.label }), "error");
                    if (newCodeRef.current) {
                      newCodeRef.current.focus();
                    }
                  } else if (res.data?.msg === "added") {
                    setLeaveTypes((prevCatg) => [...prevCatg, res.data?.doc]);
                    showToast(`${selectedDefinedLeaveType?.label} added!`, "success");
                    if (newCodeRef.current) {
                      newCodeRef.current.focus();
                    }
                    setSelectedDefinedLeaveType(null);
                  } else {
                    showToast(res.data?.msg, "error");
                  }
                } catch (error) {
                  console.log(error);
                }
              }}>
              {t('add')}
            </CustomLoadingButton>
          </div>
        </div>
      </Popover>

    </div>
  );
};

export default HrAbsence;
